import { TDeviceType, Tooltip, UIText2 } from '@cian/ui-kit';
import { clsx as cn } from 'clsx';
import * as React from 'react';

import * as styles from './MakeMoney.css';
import faqIcon from './assets/faq.svg';
import { TYPOGRAPHY, USP_DATA } from './constants';
import { Section } from '../Section';
import { SectionTitle } from '../SectionTitle';

interface IMakeMoneyProps {
  deviceType: TDeviceType;
  action: React.ReactNode;
}

export const MakeMoney: React.FC<IMakeMoneyProps> = ({ action, deviceType }) => (
  <Section deviceType={deviceType}>
    <div className={cn(styles['container'], styles[`container-${deviceType}`])} data-testid="MakeMoney">
      <header className={cn(styles[`container-header-${deviceType}`])}>
        <SectionTitle deviceType={deviceType}>{TYPOGRAPHY.SECTION_TITLE}</SectionTitle>
      </header>
      <ul className={cn(styles['usp-list'], styles[`usp-list-${deviceType}`])} data-testid="UspList">
        {USP_DATA.map(({ title, image, hasTooltip }, uspIndex) => (
          <li className={cn(styles['usp-item'], styles[`usp-item-${deviceType}`])} key={uspIndex}>
            <h3 className={styles['usp-item-title']}>
              {title}
              {hasTooltip && (
                <span>
                  &nbsp;
                  <Tooltip
                    theme="white"
                    title={
                      <div className={styles['tooltip']}>
                        <UIText2 whiteSpace="pre-wrap">{TYPOGRAPHY.TOOLTIP_TEXT}</UIText2>
                        <a href="#answersOnQuestions" className={styles['tooltip-link']}>
                          <UIText2 color="primary_100">Как мы считали</UIText2>
                        </a>
                      </div>
                    }
                  >
                    <img
                      className={styles['tooltip-icon']}
                      loading="lazy"
                      alt="Иконка для демонстрации tooltip"
                      src={faqIcon}
                    />
                  </Tooltip>
                </span>
              )}
            </h3>
            <img src={image} className={styles['usp-item-image']} alt="Изображение карточки" loading="lazy" />
          </li>
        ))}
      </ul>
      <div className={styles['action']} data-testid="MakeMoneyAction">
        {action}
      </div>
    </div>
  </Section>
);
